import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import * as Icons from "lucide-react";
import { api } from "@/lib/api";

function Icon({ name, ...rest }) {
  const Cmp = Icons[name] || Icons.Sparkles;
  return <Cmp {...rest} />;
}

export default function ServicesTeaser() {
  const [services, setServices] = useState([]);
  useEffect(() => {
    api.get("/services?featured=true").then(setServices).catch(() => setServices([]));
  }, []);

  return (
    <section className="py-24 lg:py-32 bg-secondary/30 border-y border-border" data-testid="services-teaser">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <p className="text-xs uppercase tracking-[0.3em] text-primary mb-4 font-bold">Servicios</p>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-[1]">
              De la idea a la pantalla, <span className="gradient-text">de la pantalla a la comunidad.</span>
            </h2>
          </div>
          <Link to="/servicios" data-testid="services-teaser-cta" className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-widest hover:text-primary transition-colors group">
            Ver todos los servicios
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-border rounded-sm overflow-hidden border border-border">
          {services.slice(0, 6).map((s, i) => (
            <motion.div
              key={s.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className="bg-background p-7 lg:p-9 hover:bg-secondary/40 transition-all group cursor-pointer relative"
              data-testid={`service-teaser-${s.id}`}
            >
              <div className="w-12 h-12 rounded-sm border border-border flex items-center justify-center mb-6 group-hover:border-primary group-hover:text-primary transition-colors">
                <Icon name={s.icon} className="w-5 h-5" />
              </div>
              <h3 className="font-display font-bold text-xl tracking-tight mb-3">{s.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed mb-4">{s.short_description}</p>
              <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-primary font-bold opacity-0 group-hover:opacity-100 transition-opacity">
                Ver más <ArrowRight className="w-3.5 h-3.5" />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
